import { render } from "./EmergencyAnswer.vue?vue&type=template&id=bb1bfea2&scoped=true&ts=true"
import script from "./EmergencyAnswer.ts?vue&type=script&lang=ts"
export * from "./EmergencyAnswer.ts?vue&type=script&lang=ts"

import "./EmergencyAnswer.scss?vue&type=style&index=0&id=bb1bfea2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb1bfea2"]])

export default __exports__